import { render } from "./SideMenu.vue?vue&type=template&id=48cbe410&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=48cbe410&lang=scss&scoped=true"
import "./SideMenu.vue?vue&type=style&index=1&id=48cbe410&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48cbe410"

export default script